import MyIcon from 'components/Icon';
import { MyTablePagination } from 'components/MyTable';
import Truncate from 'components/Truncate';
import React from 'react';
import { useObservable } from 'react-use-observable';
import MyTable from 'v2/components/Shared/MyTable';
import MyTableBody from 'v2/components/Shared/MyTable/MyTableBody';
import MyTableCol from 'v2/components/Shared/MyTable/MyTableCol';
import MyTableEmpty from 'v2/components/Shared/MyTable/MyTableEmpty';
import MyTableLoading from 'v2/components/Shared/MyTable/MyTableLoading';
import MyTableRow from 'v2/components/Shared/MyTable/MyTableRow';
import shoppingService from 'v2/services/shopping/product';
import tableService from 'v2/services/table';

import type { IShoppingProduct } from 'v2/interfaces/shopping';

import useStyle from '../styles';

const ProductList = ({ onClickRow }: { onClickRow: (shopping: IShoppingProduct) => void }) => {
  const classes = useStyle();
  const [isLoading] = useObservable(() => tableService.isLoading(), []);

  const [list] = useObservable(() => {
    return shoppingService.list();
  }, []);

  const [pagination] = useObservable(() => {
    return shoppingService.getPaginationResponse();
  }, []);

  const onChangeRowsPerPage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const per_page = Number(e.target.value);
    shoppingService.setPagination({ ...pagination, ...{ per_page, current_page: 1 } });
  };

  const onChangePage = (_: unknown, page: number) => {
    const current_page = page + 1;
    shoppingService.setPagination({ ...pagination, ...{ current_page } });
  };
  return (
    <>
      <MyTable responsive>
        <MyTableLoading colSpan={4} />
        <MyTableBody>
          <MyTableEmpty data={list} colSpan={4} />
          {!isLoading &&
            Array.isArray(list) &&
            list.map((shopping: IShoppingProduct, index: number) => {
              return (
                <MyTableRow key={`shopping-${index}`}>
                  <MyTableCol screenSizes={{ xs: 12, sm: 1 }} classTd={classes.colImg}>
                    <div className={classes.image} style={{ backgroundImage: `url(${shopping.product.image})` }}></div>
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 12, sm: 4 }}>
                    <div className={classes.title}>
                      <Truncate count={35} final='...'>
                        {shopping.product.title}
                      </Truncate>
                      <span>
                        contato: <a href={`mailto:${shopping.producer.email}`}>{shopping.producer.email ? shopping.producer.email : '-'}</a>
                      </span>
                    </div>
                  </MyTableCol>

                  <MyTableCol screenSizes={{ xs: 6, sm: 2 }}>
                    <div className={classes.defaultText}>{shopping.product.type}</div>
                  </MyTableCol>
                  <MyTableCol screenSizes={{ xs: 6, sm: 3 }}>
                    <div className={`${classes.defaultText} --toUpper`}>
                      {shopping.payment_status.name} {shopping.order && shopping.order.status ? `/ ${shopping.order.status}` : ''}
                    </div>
                  </MyTableCol>
                  <MyTableCol screenSizes={{ xs: 12, sm: 1 }} action>
                    <div className={classes.options}>
                      <MyIcon name='icon-product-options' onClick={() => onClickRow(shopping)} />
                    </div>
                  </MyTableCol>
                </MyTableRow>
              );
            })}
        </MyTableBody>
      </MyTable>

      {!isLoading && pagination && (
        <MyTablePagination
          onPageChange={onChangePage}
          rowsPerPage={pagination?.per_page || 0}
          count={pagination?.total_items || 0}
          page={pagination?.current_page - 1 || 0}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          labelRowsPerPage='Itens por página:'
          onChangeRowsPerPage={onChangeRowsPerPage}
          rowsPerPageOptions={[10, 20, 50, 100]}
        />
      )}
    </>
  );
};

export default ProductList;
